export const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
};

export const getUnique = <T>(arr: T[], key: (e) => string) => {
  const unique = arr
    .map((e) => key(e))
    .map((e, i, final) => final.indexOf(e) === i && i)
    .filter((i) => arr[i])
    .map((i) => arr[i]);
  return unique;
};

export const randomNum = (min = 0, max = 10000) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const devLog = (...args: unknown[]) => {
  if (process.env.NODE_ENV?.toLowerCase() === "development") {
    console.log(...args);
  }
};

export const devWarn = (...args: unknown[]) => {
  if (process.env.NODE_ENV?.toLowerCase() === "development") {
    console.warn(...args);
  }
};

export const getUUID = () => {
  if (typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  // Fallback implementation for older browsers
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    // Use crypto.getRandomValues for better randomness if available
    let r;
    if (window.crypto && crypto.getRandomValues) {
      r = crypto.getRandomValues(new Uint8Array(1))[0] % 16 | 0;
    } else {
      r = (Math.random() * 16) | 0;
    }
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Shared cookie utilities
 */
export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [key, value] = cookie.trim().split("=");
    if (key === name && value) {
      return decodeURIComponent(value);
    }
  }
  return null;
};

export const setCookie = (
  name: string,
  value: string,
  days: number,
  domain?: string
): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  const cookie =
    name +
    "=" +
    encodeURIComponent(value) +
    "; expires=" +
    expires.toUTCString() +
    "; path=/" +
    (domain ? "; domain=" + domain : "") +
    "; SameSite=Lax";
  document.cookie = cookie;
};
